import React from 'react';
import { TableBody, TableRow, Chip, Link } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import type { ConnectionSearchItem } from 'app/types';
import { formatDate } from '../../../../utils/formatter/dateTimeFormatter';
import { TableCellStyled, TableCellNameStyled } from './ConnectionsTable.styles';

type ConnectionsTableBodyProps = {
  connections: ConnectionSearchItem[];
};

export const ConnectionsTableBody = ({ connections }: ConnectionsTableBodyProps) => (
  <TableBody>
    {connections.map(connection => (
      <TableRow hover key={connection.connectionId}>
        <TableCellNameStyled>
          <Link
            component={RouterLink}
            to={`/employers/${connection.employerId}/connections/${connection.connectionId}/info`}
          >
            {connection.connectionName}
          </Link>
          {!connection.employerId && ' (no employer)'}
        </TableCellNameStyled>
        <TableCellStyled>
          <Chip label={connection.logsCount} color={connection.logsCount > 0 ? 'primary' : 'default'} size="small" />
        </TableCellStyled>
        <TableCellStyled>
          <Chip
            label={connection.eventsCount}
            color={connection.eventsCount > 0 ? 'primary' : 'default'}
            size="small"
          />
        </TableCellStyled>
        <TableCellStyled sx={{ display: 'flex' }}>
          {connection.packages
            .filter(v => v !== 'insurance-brydge')
            .map(p => (
              <Chip
                key={p}
                label={<FormattedMessage id={`packages.type.${p}`} />}
                variant="filled"
                color="primary"
                size="small"
                sx={{ mr: 0.5 }}
              />
            ))}
        </TableCellStyled>
        <TableCellStyled>{formatDate(connection.latestRun)}</TableCellStyled>
        <TableCellStyled>{formatDate(connection.createdAt)}</TableCellStyled>
      </TableRow>
    ))}
  </TableBody>
);
